import React from 'react';
import PropTypes from 'prop-types';
import NavActions from '../../actions';
import {getDataAttribute} from 'epic-common/src/browser';
import root from 'window-or-global';

export default class SiteNavKids extends React.PureComponent {
    static propTypes = {
        kids: PropTypes.array,
        isMobile: PropTypes.bool,
        isTablet: PropTypes.bool,
        parentLink: PropTypes.object,
        active: PropTypes.bool,
        activeChild: PropTypes.number,
        parentIndex: PropTypes.number
    };

    static contextTypes = {
        globalLinkOnClick: PropTypes.func
    };

    clickKidLink = (e) => {
        if (e.button && e.button > 0) return;
        const index = getDataAttribute(e.currentTarget, 'index');
        const kid = this.props.kids[index] || {};
        const href = kid.href || '';

        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            if (kid && kid.onClick && typeof kid.onClick === 'function') {
                kid.onClick(e);
            }
        }

        NavActions.closeMobileTablet.defer();
        e.stopPropagation(); //dont head up to the parent click event
    };

    back = (e) => {
        e.preventDefault();
        NavActions.mobileActiveLinkIndex(null);
    };

    showGrandKid() {
        if (typeof this.props.parentIndex === 'number') {
            const parentId = `sitenav-link-${this.props.parentIndex}`;
            let element = root.document.getElementById(parentId);
            if (!element) {
                element = root.document.getElementById(`${parentId}-collapseParent`);
            }
            if (element) {
                const classList = element.getElementsByClassName('site-nav-kids-desktop')[0].classList;
                if (!classList.contains('show-grandkid')) {
                    classList.add('show-grandkid');
                }
            }
        }
    }

    kidHover = (e) => {
        const grandKidsLength = getDataAttribute(e.currentTarget, 'gkl');
        if (!grandKidsLength || grandKidsLength < 1) {
            return;
        }
        this.showGrandKid();
    };

    kidMouseLeave = (e) => {
        const grandKidsLength = getDataAttribute(e.currentTarget, 'gkl');
        if (!grandKidsLength || grandKidsLength < 1) {
            return;
        }
        this.showGrandKid();
    };

    render() {
        //check to make sure instance of seamless immutable
        let kidArray = [];
        if (this.props.kids && this.props.kids.asMutable) {
            kidArray = this.props.kids.asMutable();
        } else {
            console.warn('[EGH] SiteNavKids Expects a seamless immutable array!!');
        }

        const isMobile = this.props.isMobile || false;
        const isTablet = this.props.isTablet || false;
        const active = this.props.active ? 'active bg-color' : '';
        let grandKids;

        if (isMobile || isTablet) {
            return (
                <ul className={`siteNavKids ${isMobile ? 'mobile mobile-list' : ''} ${isTablet ? 'tablet' : ''} ${active}`}>
                    <li className="mobile-heading" onClick={this.back} role="menuitem">
                        <a><span className="text-color-mobile-heading">{this.props.parentLink.title}</span></a>
                    </li>
                    {
                        kidArray.map((link, i) => {
                            if (link.title) {
                                return (
                                    <li
                                        role="menuitem"
                                        className="mobile-list-item"
                                        key={`sitenav-link-${link.title}`}
                                        data-index={i}
                                        onClick={this.clickKidLink}>
                                        <a
                                            className={`text-color-hover ${this.props.activeChild !== null && this.props.activeChild === i ?
                                                'active text-color-active' : 'text-color-nonactive'}`}
                                            href={link.href || '#'}
                                            target={link.target}>
                                            <span>{link.title}</span>
                                        </a>
                                    </li>
                                );
                            }

                            if (process.env.NODE_ENV !== 'production') {
                                console.warn('Site Link was not passed a title!');
                            }
                            return undefined;
                        })
                    }

                </ul>
            );
        }

        return (
            <ul className="kids site-nav-kids-desktop">
                {
                    kidArray.map((kid, i) => {
                        if (kid.hasKids && kid.isCollapsed && kid.kids) {
                            const grandKidArray = kid.kids.asMutable ? kid.kids.asMutable() : kid.kids || [];
                            grandKids = grandKidArray.map((grandKid, j) => {
                                return (
                                    <li
                                        role="menuitem"
                                        key={`sitenav-grandkid-link-${grandKid.title}`}
                                        className="grandkid"
                                        data-index={j}
                                        onClick={this.clickKidLink}>
                                        <a
                                            className={`text-color-hover ${this.props.activeChild !== null &&
                                                this.props.activeChild === i ? 'text-color-active' : 'text-color-nonactive'}`}
                                            href={grandKid.href || null}
                                            target={grandKid.target}>
                                            <span>{grandKid.title}</span>
                                        </a>
                                    </li>
                                );
                            });
                        }

                        return (
                            <li
                                role="menuitem"
                                key={`sitenav-kid-link-${kid.title}`}
                                className={`kid ${this.props.activeChild !== null &&
                                    this.props.activeChild === i ? 'active' : ''} ${grandKids && grandKids.length ? 'spread-arrow text-color-border-after' : ''}`}
                                onMouseEnter={this.kidHover}
                                onMouseLeave={this.kidMouseLeave}
                                data-gkl={grandKids && grandKids.length ? grandKids.length : 0}
                                data-index={i}
                                onClick={this.clickKidLink}>

                                <a
                                    className={`text-color-hover ${this.props.activeChild !== null &&
                                        this.props.activeChild === i ? 'text-color-active' : 'text-color-nonactive'}`}
                                    href={kid.href || '#'}
                                    target={kid.target}>
                                    <span>{kid.title}</span>
                                </a>
                                <ul className={grandKids && grandKids.length ? 'grand-kids' : 'hidden'}>{grandKids}</ul>
                            </li>
                        );
                    })
                }
            </ul>
        );
    }
}
